module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-content-8b813abaff5a306d652446baf1aef361.svg";